import * as ReselectModule from "reselect";
import { IClientRevenueListState } from ".";
import { IApplicationState } from "..";

export const selectClientRevenueList: ReselectModule.Selector<
  IApplicationState,
  IClientRevenueListState
> = (state) => state.clientRevenueList;
